'use client';

import { useCallback, useEffect, useState } from "react";
import { useIndividualsCtx, errText } from "../internals";

export const useIndividualsData = () => {
  const { storage } = useIndividualsCtx();
  const [individuals, setIndividuals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setError(null);
    try {
      setIndividuals(await storage.listIndividuals());
    } catch (e) {
      setError(errText(e));
    } finally {
      setLoading(false);
    }
  }, [storage]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { individuals, loading, error, refresh };
};
